import { css } from '@emotion/css';
import { Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const Header = () => {
    let navigate = useNavigate();


    return (
        <div style={{ background: '#f6f6f6' }}>
            <Container>
                <div className={css`
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    height: 80px;
                    @media(max-width:990px){
                        justify-content:center;
                    }
                `}>
                    <div className={css`
                    font-size: 20px;
                    font-weight: 700;
                    color: #000;
                    cursor:pointer;
                    display: flex;
                    align-items: center;
                    gap: 10px;
                `} onClick={() => navigate('/')}>
                        <img src="/images/logo.png" alt="" width={30} />
                        <div>Green<span style={{ color: '#fcc068' }}>Up</span>TX</div>
                    </div>
                </div>
            </Container>
        </div>
    )
}

export default Header